import { useState } from "preact/hooks";
import { type Translations } from "../types/translations.type";
import { isLocal } from "services/utils";
import { signal } from "@preact/signals";

type LocalizationState = {
    translations: Translations | null;
    language: string | null;
}

export const globalLocalizationState = signal<LocalizationState | null>({
    translations: null,
    language: null,
});


export type TranslationKey = keyof Translations;
//export type TranslationKey = string;

type LocalizationEntry = {
    expiration: number;
    etag: string | null;
    translations: Translations;
}

let _resolveLoadingPromise: () => void;
let _loadingPromise = new Promise<void>((resolve) => { _resolveLoadingPromise = resolve });

export async function initTranslations() {
    const language = "en";
    const translations = (await getTranslations(language)).translations as Translations;
    globalLocalizationState.value = {
        ...globalLocalizationState.value,
        translations,
        language
    };
    _resolveLoadingPromise();
}

export function useAnyTranslationsReady() {
    let [ready, setReady] = useState(!!globalLocalizationState.peek()?.language);
    _loadingPromise.then(() => setReady(true));
    return ready;
}

export function translate(key: TranslationKey, p0?: string | undefined, p1?: string | undefined): string {
    let result = globalLocalizationState.value?.translations?.[key] ?? key ?? "";
    //let result = key as string;
    if (p0)
        result = result.replace("{0}", p0);
    if (p1)
        result = result.replace("{1}", p1);
    return result;
}

async function getTranslations(language: string): Promise<LocalizationEntry> {
    const cacheLocalizationMinutes = 15;
    const expiration = new Date().getTime() + (1000 * 60 * cacheLocalizationMinutes);

    const result = await fetchTranslations(language, "default", null);
    // if (result.status == 304 && entry?.translations) {
    //     return {
    //         expiration,
    //         etag: entry.etag,
    //         translations: entry.translations
    //     };
    // }
    //if (result.ok) {
    const etag = result.headers.get("etag");
    const translations = await result.json();
    return {
        expiration, // todo: instead get from backend
        etag,
        translations
    };
}

function fetchTranslations(language: string, brand: string, etag: string | null) {
    const url = isLocal()
        ? `/translations/language-${brand}-${language}.json`
        : `/translations-proxy?brand=${brand}&language=${language}`;
    return fetch(url, {
        method: "GET",
        mode: "cors",
        headers: !etag ? undefined : {
            "If-None-Match": etag
        }
    });
}